// REACT
import React from "react";

// MATERIAL-UI
import { Grid } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
// COMPONENTS

// ASSETS
import { MultiAccountListStyles } from "./index.styles";
import anonProfilePic from "src/components/settings/profile/details/profile-picture/anon-profile-pic.png";
import ClientAccountName from "./ClientAccountName";
import { AccountUsersRes } from "src/store/features/api/generated";

const ClientAccount = (props: { account: AccountUsersRes; showTick: boolean }) => {
  const classes = MultiAccountListStyles();

  // format long names by slicing name and adding ... to end
  const formatName = (name: string): string => {
    const nameTooLong = name.length >= 23;
    return nameTooLong ? `${name.slice(0, 23)}...` : name;
  };

  return (
    <Grid container alignItems="center">
      {/* account picture */}
      <Grid item xs>
        <img src={anonProfilePic} alt="Profile" className={classes.accountPicture} />
      </Grid>

      {/* account name and id */}
      <Grid item xs={8}>
        <ClientAccountName
          primaryText={formatName(props.account.name)}
          secondaryText={props.account.customerId}
        />
      </Grid>

      {/* default account indicator */}

      <Grid item xs={2} container justifyContent="center">
        {props.showTick && <DoneIcon style={{ color: "#ccc3ae" }} />}
      </Grid>
    </Grid>
  );
};

export default ClientAccount;
